module.exports = __webpack_public_path__ + "static/media/logo_facebook.42c5ae67.svg";